import { Component, OnInit, Input, ViewChild, NgZone } from '@angular/core';
import { IonToggle, ModalController, Platform } from '@ionic/angular';
import { GlobalVariablesService } from '../../../../../services/global-variables.service';
import { StorageService } from '../../../../../services/commons/storage.service';
import { GlobalMethodsService } from '../../../../../services/global-methods.service';
import { DefaultModalComponent } from '../../../default-modal/default-modal.component';
import { SettingsService } from 'src/app/services/commons/settings.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { PanelConfService } from '../../../../../services/commons/panel-conf.service';
import { Installation } from 'src/app/models/Installation';
import { environment } from 'src/environments/environment';
import { ModalService } from '../../../../../services/commons/modal.service';
import { AuthService } from '../../../../../services/commons/auth.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {

  public user: any;
  public settings: string[] = [];
  public settingsForm: FormGroup;
  public isServiceBusy = false;
  public versionNumber: any;
  public versionToShow = '';
  public activeBiometric: boolean;
  public isDesktop: boolean;

  constructor(private modalCtrl: ModalController,
    private gvs: GlobalVariablesService,
    private storage: StorageService,
    public gms: GlobalMethodsService,
    private defaultModalComponent: DefaultModalComponent,
    private settingsService: SettingsService,
    private formBuilder: FormBuilder,
    public modalService: ModalService,
    private translate: TranslateConfigService,
    public platform: Platform,
    private panelConfService: PanelConfService,
    private authService: AuthService,
    private zone: NgZone) { }

  async ngOnInit() {
    this.gms.setLoadingTrue();
    this.versionToShow = environment.APP_VERSION + ' - ' + environment.ENVIRONMENT_SELECTED;
    this.platform.is("desktop") || this.platform.is("mobileweb") ? this.isDesktop = true : this.isDesktop = false;
    this.settingsForm = this.formBuilder.group({
      settingConnectDisconnect: new FormControl(false, [Validators.required]),
      settingStole: new FormControl(false, Validators.required),
      settingBreakdowns: new FormControl(false, Validators.required),
      settingDisconnectAlarm: new FormControl(false, Validators.required),
      settingSeeCameras: new FormControl(false, Validators.required),
      settingBiometric: new FormControl(Validators.required)
    });
    this.user = this.gvs.user;
    this.activeBiometric = (await this.authService.getUserLogin(this.gvs.user)).activeBiometric;
    this.settingsForm.controls.settingBiometric.setValue(this.activeBiometric);
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
        const settings = await this.settingsService.gAppuserSettings(this.user.userName, this.gvs.currentInstallation.s_ins);
        if (settings === undefined || settings === null) {
          this.gms.setLoadingFalse();
          await this.dismiss(false, 'settingsModal');
          return;
        }
        if (settings != null) {
          this.settings = settings.split('');
        }
    } else {
      this.modalCtrl.dismiss(false, '', 'settingsModal');
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
   await this.gms.sleep(500);
   this.gms.setLoadingFalse();
  }

  async ionViewWillEnter() {
    await this.gms.clearIntervalStatusInstallationEvent(); 
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Ajustes', contentGroup: 'Ajustes'}); 
  }

  dismiss(value, id) {
    // this.modalCtrl.dismiss({ result: value }, '', id);
    this.modalService.hide("settingsModal");
  }

  public async onSubmit() {
    if (this.isServiceBusy) {
      return;
    }
    this.gms.analyticsTrackEvent('setup_event', {eventCategory: 'SICOR/Notificaciones', eventAction: 'Accion/Guardar Click'});
    await this.gms.loading();
    if (this.settingsForm.valid) {
      const checkInternet = await this.gms.checkInternet();
      if (checkInternet) {
        this.isServiceBusy = true;
        this.settings[0] = this.settingsForm.controls.settingConnectDisconnect.value === false ? '' : 'X';
        this.settings[1] = this.settingsForm.controls.settingStole.value === false ? '' : 'X';
        this.settings[2] = this.settingsForm.controls.settingBreakdowns.value === false ? '' : 'X';
        this.settings[5] = 'X';
        this.settings[6] = 'X';
        let confSettings: string = '';
        this.settings.forEach(x => {
          if (x === 'X') {
            confSettings += "X";
          } else {
            confSettings += " ";
          }
        })
        const response = await this.settingsService.cAppuserSettings(this.user.userName, this.gvs.currentInstallation.s_ins, confSettings);
        if (response === undefined) {
          await this.dismiss(false, 'settingsModal');
          return;
        }
        const installations = await this.panelConfService.getInstallations(this.user.userName, this.gvs.lang);
        if (installations != null && installations.length > 0) {
          const installation: Installation = installations.find(x => x.selected === 1);
          if (installation != null) {
            this.gvs.currentInstallation = installation;
          } else {
            this.gvs.currentInstallation = installations[0];
          }
        }
        await this.dismiss(false, 'settingsModal');
        this.modalCtrl.dismiss(false, '', 'loadSpinner');
        if (response) {
          if(this.settings[0] === 'X'){
            this.gms.analyticsTrackEvent('setup_event', {eventCategory: 'SICOR/Notificaciones', eventAction: 'Accion/Alarma'});
          }
          if(this.settings[1] === 'X'){
            this.gms.analyticsTrackEvent('setup_event', {eventCategory: 'SICOR/Notificaciones', eventAction: 'Accion/Robo'});
          }
          if(this.settings[2] === 'X'){
            this.gms.analyticsTrackEvent('setup_event', {eventCategory: 'SICOR/Notificaciones', eventAction: 'Accion/Averias'});
          }
          await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), await this.translate.getTranslate('MESSAGES.confSettingsOk'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
        } else {
          this.gms.analyticsTrackEvent('setup_event', {eventCategory: 'SICOR/Notificaciones', eventAction: 'Accion/Guardar Configuracion'});
          await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.confSettingsKo'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
        }
        this.isServiceBusy = false;
      } else {
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
    } else {
      this.validateAllFormFields(this.settingsForm);
    }
  }

  isFieldValid(field: string) {
    return !this.settingsForm.get(field).valid && this.settingsForm.get(field).touched;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (!control.valid){
        this.gms.analyticsTrackEvent('form_error', {eventCategory: 'SICOR/Notificaciones', eventAction: 'Error/Form: Ajustes', eventLabel:'Campo: ' + field});
      }
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  async changeBio(event: any){
    if(this.activeBiometric !== event.detail.checked){
      this.zone.run(async () => {
        if(event.detail.checked){
          const result = await this.gms.checkBiometricAuth();
          if (result === 'biometric_success' || result === 'Success') {
            await this.authService.setBiometricLogin(this.user.userName, true);
            this.activeBiometric = true;
            await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), await this.translate.getTranslate('MESSAGES.activeBiometricOK'),
              'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
          }else{
            this.activeBiometric = false;
            this.settingsForm.controls.settingBiometric.setValue(!event.detail.checked);
            await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.accessBiometricKO'),
              'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
          }
        }else{
          await this.authService.setBiometricLogin(this.user.userName, false);
          this.activeBiometric = false;
          await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleInfo'), await this.translate.getTranslate('MESSAGES.disabledBiometricOK'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
        }
      });
    }
  }

}
